import React from "react";
import { TextInput, maxLength, minLength } from "react-admin";

import { parseDigits } from "../_helpers/parsers";

export const GS1CompanyPrefixInput = (props) => {
	return (
		<TextInput
			parse={(value) => (value ? parseDigits(value).slice(0, 12) : value)}
			validate={[minLength(4), maxLength(12)]}
			inputProps={{
				inputMode: "numeric",
			}}
			{...props}
		/>
	);
};
